export default __webpack_public_path__ + "static/media/hero-section-illustration.c22ab067.svg";